<template>
  <div class="chip-group-container d-flex flex-wrap">
    <StoryCityInfoChip class="half-width" color="chipPurple">
      <template v-slot:icon>
        <img src="@/assets/icons/people.svg" alt="" />
      </template>
      <template v-slot:text>
        {{ ageRating ? ageRating._id : " - " }}
      </template>
    </StoryCityInfoChip>
    <StoryCityInfoChip class="half-width" color="chipOrange">
      <template v-slot:icon>
        <img src="@/assets/icons/clock.svg" alt="" />
      </template>
      <template v-slot:text>
        {{ duration ? duration : " - " }}
      </template>
    </StoryCityInfoChip>
    <StoryCityInfoChip color="chipRed">
      <template v-if="genre" v-slot:icon>
        <!-- TODO: Genre icons should eventually be unique to the specific genre of the story, need additional designs icons for this -->
        <!-- Githuib Issue: https://story-city.atlassian.net/browse/SC-1581 -->
        <v-icon color="red" size="24px">$genre</v-icon>
      </template>
      <template v-slot:text>
        {{ genre ? genre._id : $t("storyHub.publishing.noGenre") }}
      </template>
    </StoryCityInfoChip>
    <StoryCityInfoChip color="backgroundExtraLight">
      <div
        v-if="reviews && reviews.edges.length > 0"
        class="d-flex align-center justify-center"
      >
        <v-rating
          class="mr-3"
          hover
          dense
          length="5"
          size="22"
          color="starFilled"
          background-color="starEmpty"
          empty-icon="mdi-star"
          readonly
          :value="getAverageRating(reviews)"
        />
        <div class="review-count d-flex align-center">
          <img :src="require('@/assets/icons/person.svg')" alt="" />
          <div class="count">{{ totalReviewCount }}</div>
        </div>
      </div>
      <div v-else class="count">{{ $t("storyHub.publishing.noReviews") }}</div>
    </StoryCityInfoChip>
  </div>
</template>
<script>
import StoryCityInfoChip from "@/components/StoryCityInfoChip.vue";

export default {
  props: {
    totalReviewCount: Number,
    duration: String,
    genre: Object,
    ageRating: Object,
    reviews: Object,
  },
  components: {
    StoryCityInfoChip,
  },
  methods: {
    getAverageRating(reviews) {
      let ratingCount = 0;
      let ratingTotal = 0;
      for (const review of reviews.edges) {
        ratingTotal = review.node.rating + ratingTotal;
        ratingCount++;
      }
      let average = ratingTotal / ratingCount;

      return average;
    },
  },
};
</script>
<style lang="scss" scoped>
.chip-group-container {
  gap: 10px;
}

.chip-group-container .v-chip {
  width: 100%;
}

.chip-group-container .half-width {
  width: calc(50% - 5px);
}

.count {
  color: var(--v-textOnAccent-base);
  font-size: 12px;
  font-weight: 500;
  line-height: normal;
}
</style>
